/**
 * A cor de uma iniciativa.
 *
 * Determinística pelo id, para a mesma iniciativa ter sempre a mesma cor sem
 * precisar guardar isso em banco. Vive aqui, e não dentro do Layout, porque o
 * menu e o conteúdo precisam concordar: é essa concordância que diz ao cliente
 * em qual iniciativa ele está.
 */
export const INITIATIVE_COLORS = ['#ff4d00', '#6366f1', '#10b981', '#0891b2', '#f59e0b', '#ec4899']

export function initiativeColor(id) {
  if (!id) return INITIATIVE_COLORS[0]
  return INITIATIVE_COLORS[Math.abs(Number(id) || 0) % INITIATIVE_COLORS.length]
}
